import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.css'],
    standalone: false
})
export class NavBarComponent implements OnInit {
  @Input() userName: string = '';

  constructor() { }

  ngOnInit(): void {
  }

}
